import { FilterOperator, IFilterItem } from "../../types/filters";

export const filterOutUndefinedFilters = (filters: IFilterItem[], payload: IFilterItem): IFilterItem[] => {
  let newFilters: IFilterItem[] = [...filters];

  if (payload.operator === FilterOperator.IsEqualTo && payload.value === undefined) {
    newFilters = newFilters.filter((item) => item.id !== payload.id);
  }

  if (payload.operator === FilterOperator.IsAnyOf && Array.isArray(payload?.value) && payload.value.length === 0) {
    newFilters = newFilters.filter((item) => item.id !== payload.id);
  }

  if (payload.operator === FilterOperator.IsEmpty && !payload?.value) {
    newFilters = newFilters.filter((item) => item.id !== payload.id);
  }

  return newFilters;
};
